module.exports = __webpack_public_path__ + "img/liesbeth.afedc61d.png";